/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Center__Refund_Policy__Returns__TitleInputs */

const en_help_center__refund_policy__returns__title = /** @type {(inputs: Help_Center__Refund_Policy__Returns__TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Product Returns & Warranties`)
};

/**
* | output |
* | --- |
* | "Product Returns & Warranties" |
*
* @param {Help_Center__Refund_Policy__Returns__TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const help_center__refund_policy__returns__title = /** @type {((inputs?: Help_Center__Refund_Policy__Returns__TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_Center__Refund_Policy__Returns__TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_help_center__refund_policy__returns__title(inputs)
});